<template>
    <div>
        <div id="reportContainer"></div>
    </div>
</template>

<script>
import '@/assets/ReportViewer/js/telerikReportViewer-15.0.21.326.min.js';
import Utils from '@/ecm/common/Utils';
import OrganizationService from '@/services/OrganizationService';

export default {
    name: 'report-viewer',
    props: {
        reportName: String,
        filters: String,
        load: true,
    },
    data() {
        return {
            orgLogo: '',
        };
    },
    async mounted() {
        if (!this.load) {
            return;
        }
        this.orgLogo = await OrganizationService.getLogo(currentAccount.OrganizationID);
        var params = JSON.parse(this.filters || '{}');
        params.authorization = 'bearer ' + this.$store.getters['account/token'];
        params.reportName = this.reportName;

        this.$nextTick(function() {
            this.renderReport(params);
        });
    },
    methods: {
        renderReport(params) {
            $('#reportContainer').empty();
            $('#reportContainer').append(
                "<div id='reportViewer1' style='position: absolute;top: 60px;  bottom: 10px;  left: 10px;  right: 10px;  overflow: hidden;  clear: both;'>...</div>"
            );
            $('#reportViewer1').telerik_ReportViewer({
                serviceUrl: `${this.$store.getters['account/apiUrl']}/api/reports/`,
                reportSource: {
                    report: params.reportName,
                    parameters: params,
                },
                viewMode: telerikReportViewer.ViewModes.PRINT_PREVIEW,
                scaleMode: telerikReportViewer.ScaleModes.SPECIFIC,
                scale: 1.0,
                sendEmail: { enabled: false },
            });
        },
        loadReport(reportFilters) {
            var params = JSON.parse(reportFilters || '{}');
            params.authorization = 'bearer ' + this.$store.getters['account/token'];
            var currentAccount = this.$store.getters['account/user'];
            params.currentUserId = currentAccount.Id;
            params.organizationId = currentAccount.OrganizationID;
            params.organizationName = currentAccount.OrganizationName;
            params.organizationLogo = this.orgLogo;
            params.date = Utils.date.now();

            if (!params.reportName) {
                params.reportName = this.reportName;
            }

            this.renderReport(params);
        },
    },
};
</script>
<style scoped>
body {
    font-family: Verdana, Arial;
    margin: 5px;
}
</style>